<template>
  <div id="app">

      <app-header></app-header>

    <el-main>
          <!-- Router to switch to the right page -->
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
    </el-main>
  </div>
</template>

<script>
  // This is a local call for a component
  import Element from 'element-ui'
  import axios from 'axios'

  export default {
    name: 'App',
    data() {
      return {
        test: "test"
      }
    },
    mounted : function () {
      var app = this;
      setTimeout(function () {
        let username = app.$cookie.get('user');
        if(username!== null) {
          axios.post(`https://iiot.dave.eu/api/getUserInfo`, {
            username: username,
          }).then(function (response) {
            if (response.data[0].image !== null)
              document.getElementById("avatar").src = response.data[0].image;
            app.Themer(response);
          })
        }
      }, 100)
    },
    methods :  {
      Themer(response){
        let colors = response.data[0].colors.split(",");
        let metaThemeColor = document.querySelector("meta[name=theme-color]");

        let bodyStyles = document.body.style;
        bodyStyles.setProperty('--primary-color', colors[0]);
        bodyStyles.setProperty('--secondary-color', colors[1]);
        bodyStyles.setProperty('--tertiary-color', colors[2]);

        // Set the meta theme color to reflect the change (for mobile)
        metaThemeColor.setAttribute("content", colors[0]);
      },
    }
  }
</script>

<style>
  :root{
    --primary-color: #C5C5C5!important;
    --secondary-color: #6C7478!important;
    --tertiary-color: #FFFFFF!important;
    --success-color: #80b855!important;
    --warning-color: #eaca44!important;
    --error-color: #ef4d4d!important;
  }

  /*region Theming*/
  .header{
    background-color: var(--primary-color)!important;
  }
  #username{
    color: var(--tertiary-color)!important;
  }
  .el-button--primary, .el-button{
    background-color: var(--secondary-color)!important;
    border-color: var(--primary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .el-button:hover, .el-button:active, .el-button:focus{
    background-color: var(--primary-color)!important;
    border-color: var(--secondary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .devices p:hover{
    background-color: var(--secondary-color)!important;
    border-color: var(--primary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .el-input__inner:focus{
    border-color: var(--primary-color)!important;
  }
  .el-date-picker__header-label:hover, .el-month-table td .cell:hover, .el-picker-panel__icon-btn:hover, .el-dialog__headerbtn:hover .el-dialog__close{
    color: var(--secondary-color)!important;
  }
  .el-date-table td.today span{
    color: var(--primary-color)!important;
  }
  .el-date-table td.start-date span, .el-date-table td.end-date span{
    background-color: var(--secondary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .el-date-table td.in-range div, .el-date-table td.in-range div:hover{
    background-color: var(--primary-color)!important;
  }
  .el-date-table td.in-range div span, #home a{
    color: var(--tertiary-color)!important;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover{
    background-color: var(--primary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected{
    color: var(--secondary-color)!important;
  }
  .el-date-editor .el-range__icon, .el-picker-panel__shortcut:hover{
    color: var(--primary-color)!important;
  }
  *[class*="el-icon"]{
    color: var(--primary-color);
  }
  .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner, .el-range-editor.is-active:hover, .el-range-editor.is-active{
    border-color: var(--secondary-color)!important;
  }
  .el-select-dropdown__item:hover{
    background-color: var(--primary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .el-select-dropdown__item.selected {
    color: var(--secondary-color)!important;
  }
  .el-tabs__active-bar{
    background-color: var(--secondary-color)!important;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: var(--secondary-color)!important;
    color: var(--tertiary-color)!important;
  }
  .el-loading-spinner .path{
    stroke: var(--primary-color)!important;
  }
  .el-textarea__inner:focus{
    border-color: var(--primary-color)!important;
  }
  /*endregion*/

  #app .el-icon-success{
    color: var(--success-color)!important;
  }
  #app .el-icon-warning{
    color: var(--warning-color)!important;
  }
  #app .el-icon-error{
    color: var(--error-color)!important;
  }

  /*region Scrollbar*/
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border: 16px none #ffffff;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #666666;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #888888;
  }
  ::-webkit-scrollbar-track {
    background: #ffffff;
    border: 50px #ffffff;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track:hover {
    background: #ffffff;
  }
  ::-webkit-scrollbar-track:active {
    background: #ffffff;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  /*endregion*/

  /*region Fonts*/
  * {
    font-family:-apple-system, "BlinkMacSystemFont",          /* Safari Mac/iOS, Chrome */
    'Roboto', 'Segoe UI', 'Oxygen',                           /* Windows, Android, KDE */
    'Ubuntu', 'Cantarell', 'Fira Sans',                       /* Ubuntu, Gnome, Firefox OS */
    'Droid Sans', 'Helvetica Neue', sans-serif!important;     /* Old Android */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: inherit;
    color: #2c3e50;
  }
  /*endregion*/

  /*region Other*/
  /* We want the application to feel native so we strip the ugly  */
  body{
    margin: 0;
  }
  /* This waits to display the data until it has finished rendering */
  [v-cloak]{
    display: none;
  }
  /* This overrides the default browser display to be able to show aside near main*/
  section{
    display: flex!important;
  }
  a{
    text-decoration: none;
  }
  img{
    max-height: 200px;
    transition: .15s all ease-out;
  }
  aside{
    width: 250px!important;
    overflow: hidden!important;
  }
  .el-select-dropdown__item span{
    color: inherit;
  }
  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: 0.3s;
  }

  .fade-enter-active {
    transition-delay: 0.5s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .el-button span{
    color: inherit;
  }
  .el-button.is-disabled{
    background-color: #ccc!important;
  }
  /*endregion*/
</style>



// WEBPACK FOOTER //
// src/App.vue